// Module
var code = "<div class=\"layout-row layout-align-space-between-center\">\r\n    <mx-text-box label=\"{{'solutionBuilderAgent.components.mx-search-query-condition-string.value' | mxi18n}}\" ng-model=\"vm.condition.value[0]\" custom-validation=\"vm.customValidation\" flex>\r\n\t</mx-text-box>\r\n</div>\r\n";
// Exports
export default code;